module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e8ef67af25daf4a598bfbda69d79cd27.png";